import { create } from 'zustand';
import { type BrandNamesSlice, createBrandNamesSlice } from './brandNamesSlice';
import { type CustomAudiencesSlice, createCustomAudiencesSlice } from './customAudiencesSlice';
import { createDestinationsSlice, type DestinationsSlice } from './destinationsSlice';

/** The feature's one store: definitions and the create wizard, destinations and targets, and brand names. */
export type CustomAudiencesStore = CustomAudiencesSlice & DestinationsSlice & BrandNamesSlice;

/** Builds a fresh store; the app uses the singleton below, tests build their own. */
export const createCustomAudiencesStore = () =>
  create<CustomAudiencesStore>()((...args) => ({
    ...createCustomAudiencesSlice(...args),
    ...createDestinationsSlice(...args),
    ...createBrandNamesSlice(...args)
  }));

const useCustomAudiencesStore = createCustomAudiencesStore();

export default useCustomAudiencesStore;
